import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { _className } from '../../utils/tools.js';
import './TS_Table.scss';
export class TS_Table extends React.Component {
    static defaultProps = {
        actionHeaderRenderer: (action) => _jsx("div", { children: action })
    };
    constructor(p) {
        super(p);
    }
    render() {
        const tableProps = typeof this.props.table === 'function' ? this.props.table() : this.props.table;
        const tableBodyProps = typeof this.props.body === 'function' ? this.props.body() : this.props.body;
        const tableHeadProps = typeof this.props.head === 'function' ? this.props.head() : this.props.head;
        return (_jsxs("table", { id: this.props.id, ...tableProps, className: _className('ts-table', tableProps?.className), children: [_jsx("thead", { ...tableHeadProps, className: _className('ts-table__head', tableHeadProps?.className), children: this.renderTableHeader() }), _jsx("tbody", { ...tableBodyProps, className: _className('ts-table__body', tableBodyProps?.className), children: this.renderTableBody() })] }));
    }
    renderTableHeader() {
        if (!this.props.headerRenderer)
            return;
        let renderers;
        if (typeof this.props.headerRenderer === 'object')
            renderers = this.props.headerRenderer;
        else
            renderers = this.props.header.reduce((toRet, headerProp) => {
                const prop = typeof headerProp === 'object' ? headerProp.header : headerProp;
                toRet[prop] = this.props.headerRenderer;
                return toRet;
            }, {});
        const tablePropsTR = typeof this.props.tr === 'function' ? this.props.tr(undefined, -1) : this.props.tr;
        const classNameTR = _className('ts-table__tr', tablePropsTR?.className);
        return (_jsx("tr", { ...tablePropsTR, className: classNameTR, children: this.props.header.map((header, index) => {
                const prop = typeof header === 'object' ? header.header : header;
                const tablePropsTH = typeof this.props.th === 'function' ? this.props.th(prop) : this.props.th;
                let classNameTH = _className('ts-table__th', tablePropsTH?.className);
                const style = {};
                if (typeof header === 'object') {
                    const width = typeof header.widthPx === 'number' ? `${header.widthPx}px` : header.widthPx;
                    classNameTH = _className('ts-table__th', tablePropsTH?.className, header.className);
                    style.width = width;
                    style.minWidth = typeof header.widthPx === 'number' ? width : '';
                }
                return _jsx("th", { ...tablePropsTH, className: classNameTH, style: style, children: renderers[prop]?.(prop) }, `${this.props.id}-${index}`);
            }) }, `${this.props.id}-0`));
    }
    renderTableBody() {
        let renderers;
        if (typeof this.props.cellRenderer === 'object')
            renderers = this.props.cellRenderer;
        else
            renderers = this.props.header.reduce((toRet, headerProp) => {
                const prop = typeof headerProp === 'object' ? headerProp.header : headerProp;
                toRet[prop] = this.props.cellRenderer;
                return toRet;
            }, {});
        return this.props.rows.map((row, rowIndex) => {
            const tablePropsTR = typeof this.props.tr === 'function' ? this.props.tr(row, rowIndex) : this.props.tr;
            const classNameTR = _className('ts-table__tr', tablePropsTR?.className);
            return (_jsx("tr", { ...tablePropsTR, className: classNameTR, children: this.props.header.map((header, columnIndex) => {
                    const prop = typeof header === 'object' ? header.header : header;
                    const tablePropsTD = typeof this.props.td === 'function' ? this.props.td(row, rowIndex, prop) : this.props.td;
                    let classNameTD = _className('ts-table__td', tablePropsTD?.className, typeof header === 'object' && header.className);
                    const style = {};
                    if (!this.props.headerRenderer && typeof header === 'object' && rowIndex === 0) {
                        const width = typeof header.widthPx === 'number' ? `${header.widthPx}px` : header.widthPx;
                        style.width = width;
                        classNameTD = _className('ts-table__td', tablePropsTD?.className, header.className);
                        style.minWidth = typeof header.widthPx === 'number' ? width : '';
                    }
                    return _jsx("td", { ...tablePropsTD, className: classNameTD, style: style, children: renderers[prop]?.(prop, row, rowIndex) }, `${this.props.id}-${columnIndex}`);
                }) }, `${this.props.id}-${rowIndex}`));
        });
    }
}
//# sourceMappingURL=TS_Table.js.map